import { Reveal } from "./Reveal";

const STATS = [
  ["< 2 days", "Title due diligence, down from 4–7 days"],
  ["< 5 min", "Translation across 5 Indian languages, on handwriting and bad scans"],
  ["24", "Scenario test bench behind every cheque-dishonour notice"],
  ["17", "Firms served over WhatsApp and Telegram"],
];

const CARDS = [
  {
    title: "CCI Compliance Workflows",
    body: "Merger control research across scattered Indian regulatory portals — Section 5 threshold analysis, deal value tests, exemptions and dominance assessment in one flow. Cut associate research time from four days to one.",
    link: "https://lawseek-merger-demo-frontend.vercel.app/",
    label: "Live demo",
  },
  {
    title: "Claimguard",
    body: "Indian insurers reject claims on grounds most policyholders can't evaluate, and the amounts are too small to justify a lawyer. The gap is informational, not legal. Claimguard helps a claimant understand the rejection and build a challenge. Independent solo build.",
    link: "https://grievance-craft.preview.emergentagent.com/",
    label: "Try it",
  },
  {
    title: "Recovery OS",
    body: "Banks and NBFCs write off small-value cheque dishonour and NACH defaults because pursuing them costs more than recovering them. High-volume, statutory work — exactly the shape a machine handles well. An agentic recovery system for in-house legal teams, built on open-source legal tooling.",
    link: "https://claude.ai/code/artifact/bf81b43c-4ab3-487c-be1a-212753257475",
    label: "View build",
  },
];

const Work = () => (
  <section id="work" className="wrap work-section" style={{ padding: "0 40px 96px" }} data-testid="work-section">
    <Reveal>
      <div style={{ borderTop: "1px solid var(--hairline)", paddingTop: 56, marginBottom: 48 }}>
        <div className="eyebrow" style={{ marginBottom: 16 }}>My work</div>
        <h2 style={{ margin: 0, fontSize: "var(--display-lg-size)", lineHeight: "var(--display-lg-lh)", letterSpacing: "var(--display-lg-ls)", fontWeight: "var(--weight-thin)", color: "var(--ink)" }}>
          What I'm building, and what I built on the way
        </h2>
      </div>
    </Reveal>

    <Reveal>
      <div className="card-featured" data-testid="lawseek-card">
        <div style={{ position: "relative", display: "flex", gap: 56, flexWrap: "wrap", alignItems: "flex-start" }}>
          <div style={{ flex: "1 1 440px", minWidth: 0 }}>
            <span style={{ display: "inline-flex", alignItems: "center", border: "1px solid rgba(255,255,255,0.35)", color: "rgba(255,255,255,0.85)", fontSize: "var(--micro-cap-size)", letterSpacing: "var(--micro-cap-ls)", lineHeight: "var(--micro-cap-lh)", textTransform: "uppercase", fontWeight: 400, padding: "4px 10px", borderRadius: "var(--radius-pill)" }}>Now</span>
            <h3 style={{ margin: "20px 0 0", fontSize: "var(--display-md-size)", lineHeight: "var(--display-md-lh)", letterSpacing: "var(--display-md-ls)", fontWeight: "var(--weight-thin)", color: "var(--on-primary)" }}>
              LawSeek — AI paralegals for hire
            </h3>
            <p style={{ margin: "16px 0 0", fontSize: "var(--body-md-size)", lineHeight: 1.7, fontWeight: "var(--weight-thin)", color: "rgba(255,255,255,0.78)" }}>
              Outcome as a service for high-volume legal work. Indian lawyers weren't buying software — they were asking us to do the work. So we stopped selling tools and started delivering finished output over WhatsApp and Telegram, across three use cases: property title due diligence, translations, and cheque-bounce recovery.
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 24, marginTop: 28 }}>
              <a href="https://www.lawseek.ai" target="_blank" rel="noopener" className="link-ondark" style={{ fontSize: "var(--body-md-size)", fontWeight: 400 }} data-testid="lawseek-link">lawseek.ai →</a>
            </div>
          </div>
          <div style={{ flex: "1 1 380px", minWidth: 0, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 0 }}>
            {STATS.map(([num, label], i) => (
              <div key={i} style={{ borderTop: "1px solid rgba(255,255,255,0.16)", padding: i % 2 === 0 ? "20px 24px 20px 0" : "20px 0 20px 24px", borderLeft: i % 2 === 1 ? "1px solid rgba(255,255,255,0.16)" : "none" }}
                data-testid={`lawseek-stat-${i}`}>
                <div className="stat-num" style={{ fontSize: 26, fontWeight: "var(--weight-thin)", color: "var(--on-primary)", fontFeatureSettings: "'tnum'" }}>{num}</div>
                <div style={{ marginTop: 8, fontSize: "var(--caption-size)", letterSpacing: "var(--caption-ls)", lineHeight: "var(--caption-lh)", color: "rgba(255,255,255,0.6)" }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Reveal>

    <Reveal>
      <div className="eyebrow" style={{ margin: "56px 0 24px" }}>Built along the way</div>
    </Reveal>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 300px), 1fr))", gap: 24 }}>
      {CARDS.map((c, i) => (
        <Reveal key={c.title} delay={i * 0.08} style={{ display: "flex" }}>
          <div className="work-card" style={{ flex: 1 }} data-testid={`work-card-${i}`}>
            <h3 style={{ margin: 0, fontSize: "var(--heading-md-size)", lineHeight: "var(--heading-md-lh)", letterSpacing: "var(--heading-md-ls)", fontWeight: 400, color: "var(--ink)" }}>{c.title}</h3>
            <p style={{ margin: 0, flex: 1, fontSize: "var(--body-md-size)", lineHeight: 1.65, fontWeight: "var(--weight-thin)", color: "var(--ink-secondary)" }}>{c.body}</p>
            <a href={c.link} target="_blank" rel="noopener" className="link-primary" style={{ fontSize: "var(--body-md-size)", fontWeight: "var(--weight-thin)" }} data-testid={`work-card-link-${i}`}>
              {c.label} <span className="arrow">→</span>
            </a>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Work;
